export interface UserType {
  uid: string;
  email: string;
  photoURL?: string;
  displayName?: string;
  name?: string;
  surname?: string;
  phoneNumber?: string;
  country?: string;
  region?: string;
  inspectionReportViewer?: boolean;
  isReviewer?: boolean;
  reviewing?: string;
  reviewingFingerprint?: string;
  isSadlViewer?: boolean;
  partnership?: string;
  partnerApplicationStatus?: string;
}

export enum InspectionPictureType {
  certificateOfRegistration,
  roadworthyDisc,
  operatorCard,
  clientSignature,
  rearLeft,
  rearRight,
  frontLeft,
  frontRight,
  bootInterior,
  frontDash,
  frontLeftDoor,
  frontRightDoor,
  frontRoof,
  interiorCeiling,
  odometer,
  rearLeftDoor,
  rearRightDoor,
  rearRoof,
  rearSeats,
  frontSeats,

}


export interface FireBaseDataUpdate {
  [key: string]: any;
}

export interface InspectionsType {
  //[key: string]: any;

  location?: string;
  numberPlate?: string;
  vin?: string;
  engineNumber?: string;
  year?: string;
  vehicleHistory?: string;
  vehicleTareWeight?: number;
  vehicleType?: string;
  operatorCard?: string;
  make?: string;
  model?: string;
  uid?: string;
  paid?: boolean;
  pictureOfCertificateOfRegistration?: ImageType;
  pictureOfRoadworthyDisc?: ImageType;
  pictureOfOperatorCard?: ImageType;
  vehicleBarcode?: string;
  clientSignature?: ImageType;
  pictureOf45DegreeBackLeft?: ImageType;
  pictureOf45DegreeBackRight?: ImageType;
  pictureOf45DegreeLeft?: ImageType;
  pictureOfBootInterior?: ImageType;
  pictureOfCar?: ImageType;
  pictureOfFrontDash?: ImageType;
  pictureOfFrontLeftDoorPanel?: ImageType;
  pictureOfFrontRightSidePanel?: ImageType;
  pictureOfFrontRoof?: ImageType;
  pictureOfInteriorCeiling?: ImageType;
  pictureOfLicenseDisc?: ImageType;
  pictureOfMileage?: ImageType;
  pictureOfOperatingLicence?: ImageType;
  pictureOfRearLeftDoorPanel?: ImageType;
  pictureOfRearRightSidePanel?: ImageType;
  pictureOfRearRoof?: ImageType;
  rearSeats?: ImageType;
  mileage?: number;
  interiorColour?: string;
  interiorType?: string;
  frontSeats?: ImageType;
  interior?: string;
  exterior?: string;
  colour?: string;
  hasAirbags?: boolean;
  hasAircon?: boolean;
  hasAlarmImmobilizer?: boolean;
  hasBluetooth?: boolean;
  hasBrandingWrapRemoval?: boolean;
  hasCarpets?: boolean;
  hasCdChanger?: boolean;
  hasCdPlayer?: boolean;
  hasCellPhoneKit?: boolean;
  hasClimateControl?: boolean;
  hasDvdPlayer?: boolean;
  hasElectricWindows?: boolean;
  hasMP3Player?: boolean;
  hasMediaInterface?: boolean;
  hasNavigation?: boolean;
  hasNudgeBar?: boolean;
  hasPanoramicRoof?: boolean;
  hasRoofRack?: boolean;
  hasRunningBoards?: boolean;
  hasSmashAndGrab?: boolean;
  hasSunRoof?: boolean;
  hasXenonLights?: boolean;
  radio?: boolean;
  canceled?: boolean;
  createdBy: string;
  inspectionDate: number;
  lastRoadworthyTest?: number;
  lastRoadworthyTestString?: string;
  finished?: boolean;
  order?: OrderType;
}


type ImageTypeKeys<T> = {
    [K in keyof T]: T[K] extends (ImageType | undefined)  ? K : never;
}[keyof T];

type InspectionPictureKeys = ImageTypeKeys<InspectionsType>;

export const InspectionPictureLocations: Record<InspectionPictureType, InspectionPictureKeys> = {
  [InspectionPictureType.certificateOfRegistration]: "pictureOfCertificateOfRegistration",
  [InspectionPictureType.roadworthyDisc]: "pictureOfRoadworthyDisc",
  [InspectionPictureType.operatorCard]: "pictureOfOperatorCard",
  [InspectionPictureType.clientSignature]: "clientSignature",
  [InspectionPictureType.rearLeft]: "pictureOf45DegreeBackLeft",
  [InspectionPictureType.rearRight]: "pictureOf45DegreeBackRight",
  [InspectionPictureType.frontLeft]: "pictureOf45DegreeLeft",
  [InspectionPictureType.frontRight]: "pictureOfCar",
  [InspectionPictureType.bootInterior]: "pictureOfBootInterior",
  [InspectionPictureType.frontDash]: "pictureOfFrontDash",
  [InspectionPictureType.frontLeftDoor]: "pictureOfFrontLeftDoorPanel",
  [InspectionPictureType.frontRightDoor]: "pictureOfFrontRightSidePanel",
  [InspectionPictureType.frontRoof]: "pictureOfFrontRoof",
  [InspectionPictureType.interiorCeiling]: "pictureOfInteriorCeiling",
  [InspectionPictureType.odometer]: "pictureOfMileage",
  [InspectionPictureType.rearLeftDoor]: "pictureOfRearLeftDoorPanel",
  [InspectionPictureType.rearRightDoor]: "pictureOfRearRightSidePanel",
  [InspectionPictureType.rearRoof]: "pictureOfRearRoof",
  [InspectionPictureType.rearSeats]: "rearSeats",
  [InspectionPictureType.frontSeats]: "frontSeats",
}

export interface ImageType {
  basePath: string;
  createdAt: Date;
  name: string;
  size: number;
  thumbUrl: string;
  type: string;
  url: string;
  exifdata: ExifType;
}

export interface ExifType {
  BrowserLocation: {
    lat: number | null;
    lng: number | null;
  };
  MakerNote: string;
}

export enum FingerprintPictureType {
  clientSignature,
  selfie,
  id,
  passport,
  workPermit,
  PDPFront,
  PDPBack,
  SATRNCertificate,

}


export interface FingerprintsType {
  auditType?: string;
  uid: string;
  createdBy: string;
  paid: boolean;
  name?: string;
  nationality?: string;
  surname?: string;
  gender?: string;
  idOrPassport?: string;
  passportCountry?: string;
  populationGroup?: string;
  prdpNumber?: string;
  satrnNumber?: string;
  address?: string;
  birthCountry?: string;
  phoneNumber?: string;
  emailAddress?: string;
  finished?: boolean;
  finishedAuditDate?: string;
  canceled?: boolean;
  date: number;
  completedDate?: number;
  // partner?: Partial<PartnerIntf>;
  paymentDetail?: any;
  pictureOfSelf?: ImageType;
  pictureOfSelfQuality?: string;
  pictureOfSelfVerified?: boolean;
  pictureOfID?: ImageType;
  pictureOfPassport?: ImageType;
  pictureOfWorkPermit?: ImageType;
  pictureOfIDQuality?: string;
  pictureOfIDVerified?: boolean;
  pictureOfPDPFront?: ImageType;
  pictureOfPDPFrontQuality?: string;
  pictureOfPDPFrontVerified?: boolean;
  pictureOfPDPBack?: ImageType;
  pictureOfPDPBackQuality?: string;
  
  pictureOfPDPBackVerified?: boolean;
  pictureOfSATRNCertificate?: ImageType;
  pictureOfSATRNCertificateQuality?: string;
  pictureOfSATRNCertificateVerified?: boolean;
  matchSelfie_ID?: boolean;
  matchSelfie_PDP?: boolean;
  matchID_PDP?: boolean;
  busyResubmit?: boolean;
  // mieIDPictureURL?: SafeResourceUrl;
  IDVbirthCountry?: string;
  IDVDOB?: string;
  IDVgender?: string;
  IDVissueDate?: string;
  IDVname?: string;
  IDVsurname?: string;
  clientSignature?: ImageType;
  redo: { [key: string]: boolean };
  sendForResubmit?: boolean;
  reviewedBy?: string;
  sentForReview?: number;
  state: string;
  consentDetails?: boolean;
  consentMarketing?: boolean;
  declareClient?: boolean;
  declareInfo?: boolean;
  reviewNotes?: string;
  resubmitNotesToClient?: string;
  location?: string;
  usePassport: boolean;
  birthday?: string;
  order?: OrderType;
}

type FingerprintPictureKeys = ImageTypeKeys<FingerprintsType>;

export const FingerprintPictureLocations: Record<FingerprintPictureType, FingerprintPictureKeys> = {
  [FingerprintPictureType.clientSignature]: "clientSignature",
  [FingerprintPictureType.id]: "pictureOfID",
  [FingerprintPictureType.PDPBack]: "pictureOfPDPBack",
  [FingerprintPictureType.PDPFront]: "pictureOfPDPFront",
  [FingerprintPictureType.passport]: "pictureOfPassport",
  [FingerprintPictureType.SATRNCertificate]: "pictureOfSATRNCertificate",
  [FingerprintPictureType.selfie]: "pictureOfSelf",
  [FingerprintPictureType.workPermit]: "pictureOfWorkPermit",
}

export type PictureType = FingerprintPictureType | InspectionPictureType;

export interface MyCheckType {
  type: string;
  uid: string;
  identifier: string;
  date: number;
  state: string;
}

export interface OrderType {
  type: string;
  email?: string;
  inspectionId?: string;
  fingerprintId?: string;
  date?: number;
  dateString?: string;
  name?: string;
  surname?: string;
  inspectionDate?: number;
  inspectionDateString?: string;
  numberPlate?: string;
  numberOfCoupons?: number;
  fingerPrintCoupons?: number;
  inspectionCoupons?: number;
  uid: string;
  id: string;
  amount: number;
  clientRef: string;
  processed?: boolean;
}

export interface PublicKeyType {
  yoco: string;
}

export interface ReportType {
  basePath: string;
  createdAt: number;
  name: string;
  type: string;
  url: string;
}
